import React from 'react';
import { Link } from 'react-router-dom';
import "./Special.css";
import { useTranslation } from 'react-i18next';

function Special() {
  const { t } = useTranslation();

  return (
    <div className='spacial-container'>
      <div className="spacial-content">

        <div className='spacial-header'>
          <h3>{t('nav_pruduct_special')}</h3>
        </div>
        <div className='pro-text-promotion'>
          <p>{t('special-p-one')}</p>
          <p>{t('special-p-two')}</p>
          <p>{t('special-p-three')}</p>


        </div>

        <div className='spacial-features'>
          <div className='spacial-features-header'>
            <h3>{t('sealing-norm-header-text')}</h3>
          </div>
          <p><strong>{t('sealing-norm-p-one')}</strong>{t('special-norm-info-one')}</p>
          <p><strong>{t('sealing-norm-p-two')}</strong>{t('special-norm-info-two')}</p>
          <p><strong>{t('sealing-norm-p-three')}</strong>{t('special-norm-info-three')}</p>

          <p>{t('drinkwater-norm-detail-text')}</p>


        </div>


        <div className='info-contact'>
          <Link to="/contact" className='btn-contact'>{t('sealing-norm-button')}</Link>
        </div>

      </div>
    </div>
  )
}

export default Special
